var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembersIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 72,
    viewBox: "0 0 64 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.6667 70.5C62.6667 65.1503 62.6667 62.4755 62.0064 60.299C60.5199 55.3984 56.6849 51.5635 51.7844 50.0769C49.6078 49.4167 46.933 49.4167 41.5833 49.4167H22.4167C17.067 49.4167 14.3922 49.4167 12.2156 50.0769C7.31509 51.5635 3.48016 55.3984 1.9936 60.299C1.33334 62.4755 1.33334 65.1503 1.33334 70.5M49.25 18.75C49.25 28.2769 41.5269 36 32 36C22.4731 36 14.75 28.2769 14.75 18.75C14.75 9.22309 22.4731 1.5 32 1.5C41.5269 1.5 49.25 9.22309 49.25 18.75Z",
    stroke: "#475467",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembersIc);
export default __webpack_public_path__ + "static/media/members_ic.fe50c979.svg";
export { ForwardRef as ReactComponent };